export enum HasAccess {
  YES = 'YES',
  NO = 'NO',
}
